import Landing from "../components/Landing";
import Collection from "../components/Collection";

export const LandingSection = {
  key: "gant--landing-section",
  component: Landing,
};

export const CollectionSection = {
  key: "gant--collection-section",
  component: Collection,
};

export const DatoKeyValuesMap = [LandingSection, CollectionSection];
